/**
 * PixQrcodeModal Component
 * 
 * Modal específico para criar/editar forma de recebimento do tipo PIX QRCode.
 */

import { useState, useEffect } from 'react'
import Modal from '../../../../../components/ERP/Modal/Modal'
import FormField from '../../../../../components/ERP/Form/FormField'
import { Smartphone } from 'lucide-react'

function PixQrcodeModal({ isOpen, onClose, onSubmit, editingForma, accounts, errors }) {
  console.log('PixQrcodeModal renderizado, isOpen:', isOpen, 'editingForma:', editingForma)
  
  const [formData, setFormData] = useState({
    name: 'PIX QRCode',
    description: '',
    accountId: '',
    taxRate: '0',
    active: true
  })

  useEffect(() => {
    console.log('PixQrcodeModal useEffect, isOpen:', isOpen, 'editingForma:', editingForma)
    if (editingForma) {
      setFormData({
        name: editingForma.name || 'PIX QRCode',
        description: editingForma.description || '',
        accountId: editingForma.account_id || '',
        taxRate: editingForma.tax_rate ? parseFloat(editingForma.tax_rate).toFixed(2) : '0',
        active: editingForma.active !== undefined ? editingForma.active : true
      })
    } else {
      setFormData({
        name: 'PIX QRCode',
        description: '',
        accountId: '',
        taxRate: '0',
        active: true
      })
    }
  }, [editingForma, isOpen])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      provider: 'PIX',
      paymentType: 'PIX_QRCODE',
      installments: null,
      cardBrand: null,
      requiresConfirmation: false
    })
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editingForma ? 'Editar PIX QRCode' : 'Nova Forma: PIX QRCode'}
      icon={<Smartphone size={24} />}
      size="medium"
      footer={
        <>
          <button
            className="btn-secondary"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            className="btn-primary"
            onClick={handleSubmit}
          >
            {editingForma ? 'Salvar' : 'Criar'}
          </button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <FormField
          label="Nome *"
          name="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          error={errors.name}
          required
          placeholder="Ex: PIX QRCode PagSeguro"
        />

        <FormField
          label="Descrição"
          name="description"
          type="textarea"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          error={errors.description}
          placeholder="Descrição opcional"
        />

        <FormField
          label="Conta Bancária *"
          name="accountId"
          type="select"
          value={formData.accountId}
          onChange={(e) => setFormData({ ...formData, accountId: e.target.value })}
          error={errors.accountId}
          required
          options={[
            { value: '', label: 'Selecione uma conta bancária' },
            ...accounts.map(account => ({
              value: account.id.toString(),
              label: `${account.code} - ${account.name}`
            }))
          ]}
        />

        <FormField
          label="Taxa (%)"
          name="taxRate"
          type="number"
          step="0.01"
          min="0"
          max="100"
          value={formData.taxRate}
          onChange={(e) => setFormData({ ...formData, taxRate: e.target.value })}
          error={errors.taxRate}
          placeholder="0.00"
          helpText="Taxa percentual do provedor (ex: 0.99 para 0,99%)"
        />

        <FormField
          label="Status"
          name="active"
          type="select"
          value={formData.active ? 'true' : 'false'}
          onChange={(e) => setFormData({ ...formData, active: e.target.value === 'true' })}
          error={errors.active}
          options={[
            { value: 'true', label: 'Ativa' },
            { value: 'false', label: 'Inativa' }
          ]}
        />

        {errors.submit && (
          <div className="form-error-message">{errors.submit}</div>
        )}
      </form>
    </Modal>
  )
}

export default PixQrcodeModal
